"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../actions/types");
var initialState = '';
var currentChatReducer = function currentChatReducer() {
  var previousCurrentChat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    _action$value = action.value,
    value = _action$value === void 0 ? {} : _action$value;
  switch (type) {
    case _types.UPDATE_RENDER_PROPS:
      {
        var _value$roomname = value.roomname,
          roomname = _value$roomname === void 0 ? '' : _value$roomname;
        return roomname;
      }
    case _types.CHANGE_CURRENT_CHAT:
    case _types.LOAD_CHAT_DONE:
    case _types.LOAD_CHAT_ERROR:
      {
        var _value$chat = value.chat,
          chat = _value$chat === void 0 ? {} : _value$chat;
        var _ref = chat || {},
          _ref$roomname = _ref.roomname,
          _roomname = _ref$roomname === void 0 ? '' : _ref$roomname;
        return _roomname;
      }
    default:
      return previousCurrentChat;
  }
};
var _default = exports["default"] = currentChatReducer;